module.exports = __webpack_public_path__ + "img/img51.980342e5.svg";